'use client';

function wrapWithSelector(selectors, code) {
  var _selectors = Array.isArray(selectors) ? selectors : [selectors];

  return _selectors.reduce(function (acc, selector) {
    return "".concat(selector, "{").concat(acc, "}");
  }, code);
}

export { wrapWithSelector };